import { RepriceOrderPanel } from "@/components/command-bar/panels";
import type { Command } from "@/lib/commands/types";

// Pricing commands are gated by feature_dynamic_pricing. Drafts
// management is a navigation command (the page hosts the lifecycle
// UI); reprice is a contextual mutation on an order detail page.
export const commandsPricing: Command[] = [
  {
    id: "pricing.open_drafts",
    label: "Open pricing drafts",
    group: "pricing",
    scope: "global",
    permission: "org:pricing:read",
    featureFlag: "feature_dynamic_pricing",
    handler: { kind: "navigate", href: "/pricing/drafts" },
    keywords: ["draft", "engine"],
  },
  {
    id: "pricing.reprice_order",
    label: "Reprice this order",
    group: "pricing",
    scope: "global", // We allow it whenever orderId is in context, even if not
                     // on a dedicated order detail page; the panel guards.
    permission: "org:pricing:write",
    featureFlag: "feature_dynamic_pricing",
    handler: { kind: "panel", open: RepriceOrderPanel },
  },
];
